import React, {
  memo, useMemo, useState, useEffect,
} from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TooltipUI from '../../../../components/UI/Tooltip/Tooltip';
import { TableWithAccordion } from '../AcordosStyle';
import { useUtilStyles } from '../../../../helpers';

const useStyles = makeStyles(() => ({
  checkboxDisabled: {
    color: '#034bdcb5 !important',
  },
}));

function getAlignOption(row, column) {
  let alignOption = row.values[column.id] ? column.alignCell : 'center';
  if (!row.values[column.id] && column.showTip) {
    alignOption = 'center';
  }
  return alignOption;
}

function Row({
  row,
  columns,
  checked,
  onCheck,
}) {
  const styles = useUtilStyles();
  const classes = useStyles();

  const getContent = (value, column) => {
    const formattedValue = column.format && typeof value === 'number'
      ? column.format(value)
      : value;

    if (column.showTip) {
      return (
        <TooltipUI title={formattedValue} placement="bottom" interactive>
          <span className={styles.overFlowText}>
            {formattedValue}
          </span>
        </TooltipUI>
      );
    }

    return (
      <span className={styles.overFlowText}>
        {formattedValue}
      </span>
    );
  };

  return (
    <TableRow
      className={styles.tableRowRoot}
      style={{ backgroundColor: checked ? '#f0f6ff' : 'inherit' }}
    >
      <TableCell padding="checkbox" style={{ borderBottom: '1px solid #e0e0e0' }}>
        <Checkbox
          checked={checked}
          onChange={e => onCheck(row.id, e.target.checked)}
          classes={{
            root: classes.checkboxBlue,
            checked: classes.checkboxChecked,
            disabled: classes.checkboxDisabled,
          }}
          disabled
        />
      </TableCell>

      {columns.map((column) => {
        const value = row.values[column.id];
        const alignOption = getAlignOption(row, column);

        return (
          <TableCell
            key={column.id}
            style={{
              maxWidth: column.maxWidth,
              minWidth: column.minWidth,
              width: column.width,
              borderBottom: '1px solid #e0e0e0',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: alignOption,
              }}
            >
              {getContent(value, column)}
            </div>
          </TableCell>
        );
      })}
    </TableRow>
  );
}

function TabelaPropostaAcordos({ columns = [], rows = [], rowsPerPage }) {
  const [selectedRows, setSelectedRows] = useState([]);

  useEffect(() => {
    const defaultSelectedRows = rows
      .filter(row => row?.values?.pertencenteAoAcordo)
      .map(row => row.id);

    setSelectedRows(defaultSelectedRows);
  }, [rows]);

  const columnLength = useMemo(
    () => columns.length + 1,
    [columns.length],
  );

  const handleCheck = (id, isChecked) => {
    if (isChecked) {
      setSelectedRows(prev => [...prev, id]);
    } else {
      setSelectedRows(prev => prev.filter(item => item !== id));
    }
  };

  const buildEmptyRows = () => {
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length);
    const content = [];

    for (let i = 0; i < emptyRows; i += 1) {
      content.push(
        <TableRow key={i} style={{ height: 31 }}>
          <TableCell colSpan={columnLength}>
            <p />
          </TableCell>
        </TableRow>,
      );
    }

    return content;
  };

  return (
    <TableWithAccordion>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell padding="checkbox" style={{ textAlign: 'center' }}>
              Selecionado
            </TableCell>

            {columns.map(column => (
              <TableCell
                key={column.id}
                style={{
                  maxWidth: column.maxWidth,
                  minWidth: column.minWidth,
                  width: column.width,
                  textAlign: column.align,
                }}
              >
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {rows.map(row => (
            <Row
              key={row.id}
              row={row}
              columns={columns}
              checked={selectedRows.includes(row.id)}
              onCheck={handleCheck}
            />
          ))}

          {buildEmptyRows()}
        </TableBody>
      </Table>
    </TableWithAccordion>
  );
}

export default memo(TabelaPropostaAcordos);
